<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field [appearance]="appearance" class="fuse-mat-dense flex-auto">
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }

    <input
      matInput
      type="text"
      [name]="controlName"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [id]="inputId"
      [autocomplete]="autocomplete"
      (blur)="doBlur()"
      [maxLength]="maxLength"
      [readonly]="readonly"
    />

    @if (icon) {
      <mat-icon matSuffix ngClass="{{ 'icon-size-' + iconSize }}" svgIcon="{{ icon }}"></mat-icon>
    }

    @if (validateField.hasErrorValidate(formControl, 'required')) {
      <mat-error>{{ t(errorRequired) }}</mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'minlength')) {
      <mat-error>
        {{ t('minimum') | titlecase }}
        {{ validateField.validateLength(formControl, 'minlength') }}
        {{ t('characters') }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'maxlength')) {
      <mat-error>
        {{ t('maximum') | titlecase }}
        {{ validateField.validateLength(formControl, 'maxlength') }}
        {{ t('characters') }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'invalidDocument')) {
      <mat-error>
        {{ t('invalid-document') | capitalize }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'invalidTimeFormat')) {
      <mat-error>
        {{ t('time-format') | capitalize }}
      </mat-error>
    }
  </mat-form-field>
</div>
